import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  submitForm(event) {
    const email = event.target.value.trim();
    if (email) {
      // Prevenir múltiples submits
      if (this.isSubmitting) {
        return;
      }
      this.isSubmitting = true;

      setTimeout(() => {
        this.checkEmail(email);
        setTimeout(() => {
          this.isSubmitting = false;
        }, 1000);
      }, 100);
    }
  }

  checkEmail(email) {
    const form = this.element.closest("form");
    if (!form) return;

    const url = form.action.replace("/checkout_form", "/check_email");
    const formData = new FormData();

    formData.append(
      "showcase_checkout_checkout_form[sale_params][user][email]",
      email
    );

    fetch(url, {
      method: "POST",
      body: formData,
      headers: {
        Accept: "text/vnd.turbo-stream.html",
        "X-CSRF-Token": document.querySelector('meta[name="csrf-token"]')
          .content,
      },
    })
      .then((response) => response.text())
      .then((html) => {
        if (html.trim()) {
          Turbo.renderStreamMessage(html);
        }
      })
      .catch((error) => {
        console.error("Error checking email:", error);
      });
  }
}
